import { useQuery } from "@apollo/client";
import { GET_CUSTOMERS_GROUPS } from "@/containers/B2BCustomers/B2BCustomersQueries";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface CustomerGroupSelectProps {
  field: any;
}

const CustomerGroupSelect: React.FC<CustomerGroupSelectProps> = ({ field }) => {
  const { data, loading, error } = useQuery(GET_CUSTOMERS_GROUPS);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading customer groups</div>;

  const customerGroups = data?.findManyCustomerGroup || [];

  return (
    <Select
      onValueChange={(value) => field.onChange(Number(value))}
      value={field.value ? String(field.value) : undefined}
    >
      <SelectTrigger>
        <SelectValue placeholder="Select a customer group" />
      </SelectTrigger>
      <SelectContent>
        {customerGroups.map((group: any) => (
          <SelectItem key={group.id} value={String(group.id)}>
            {group.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default CustomerGroupSelect;
